import { useData } from "./DataContext.js";

import Alert from "./Alert.js";

export default function AlertList (props)
{
    const gData = useData();

    const alertList = Object.values(gData.alerts).map((alert) => (<Alert key={alert.alertID} variant={alert.variant} title={alert.title} content={alert.content}/>));
    
    return (
	<div className="position-fixed gap-0 d-flex flex-column align-items-start" style={{ zIndex: 1000, left: "20px", top: Object.keys(gData.content).length === 0 ? "20px" : "100px" }}>
	    {alertList}
	</div>
    );
}
